
    <template>
      <section class="relax-doc">
        <h1>Tabs 标签页</h1>
<blockquote>
<p>选项卡切换组件。</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>默认</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-tabs&gt;
    &lt;x-tab-pane label=&quot;Tab 1&quot;&gt;
      这是选项卡1
    &lt;/x-tab-pane&gt;
    &lt;x-tab-pane label=&quot;Tab 2&quot;&gt;
      这是选项卡2
    &lt;/x-tab-pane&gt;
  &lt;/x-tabs&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="jin-yong"><a class="header-anchor" href="#jin-yong"></a> 禁用</h2>
<blockquote>
<p>禁用不可点击的tab</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-tabs&gt;
    &lt;x-tab-pane label=&quot;Tab 1&quot;&gt;
      这是选项卡1
    &lt;/x-tab-pane&gt;
    &lt;x-tab-pane label=&quot;Tab 2&quot; disabled&gt;
      这是选项卡2
    &lt;/x-tab-pane&gt;
    &lt;x-tab-pane label=&quot;Tab 3&quot;&gt;
      这是选项卡3
    &lt;/x-tab-pane&gt;
  &lt;/x-tabs&gt;
&lt;/template&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_tab_pane = _resolveComponent("x-tab-pane")
  const _component_x_tabs = _resolveComponent("x-tabs")

  return (_openBlock(), _createBlock(_component_x_tabs, null, {
    default: _withCtx(() => [
      _createVNode(_component_x_tab_pane, { label: "Tab 1" }, {
        default: _withCtx(() => [
          _createTextVNode(" 这是选项卡1 ")
        ]),
        _: 1
      }),
      _createVNode(_component_x_tab_pane, { label: "Tab 2" }, {
        default: _withCtx(() => [
          _createTextVNode(" 这是选项卡2 ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { createTextVNode: _createTextVNode, resolveComponent: _resolveComponent, withCtx: _withCtx, createVNode: _createVNode, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_tab_pane = _resolveComponent("x-tab-pane")
  const _component_x_tabs = _resolveComponent("x-tabs")

  return (_openBlock(), _createBlock(_component_x_tabs, null, {
    default: _withCtx(() => [
      _createVNode(_component_x_tab_pane, { label: "Tab 1" }, {
        default: _withCtx(() => [
          _createTextVNode(" 这是选项卡1 ")
        ]),
        _: 1
      }),
      _createVNode(_component_x_tab_pane, {
        label: "Tab 2",
        disabled: ""
      }, {
        default: _withCtx(() => [
          _createTextVNode(" 这是选项卡2 ")
        ]),
        _: 1
      }),
      _createVNode(_component_x_tab_pane, { label: "Tab 3" }, {
        default: _withCtx(() => [
          _createTextVNode(" 这是选项卡3 ")
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  